var Shopify = Shopify || {};

Shopify.money_format = window.cartStrings.money_format || "£{{amount}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'", ".");
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

class PersonalisedBundle extends HTMLElement {
    productChangeEvents = ["personalise-bundle:product-added", "personalise-bundle:quantity:changed"];
    perkProductChangeEvents = ["personalise-bundle:free-product-added", "personalise-bundle:free-product-quantity:changed"];

    constructor() {
        super();
        this.data = {
            products_array: [],
            current_amount: 0,
            tier_details: [],
            current_step: 1,
            perks: {
                limit: 3,
                products_array: [],
                perks_details: []
            },
            free_gift_wrap_product: ""
        }
    }

    connectedCallback() {
        const tiersDetailsScript = this.querySelector("#tier_details");
        if (tiersDetailsScript) {
            const tierDetails = JSON.parse(tiersDetailsScript.textContent);
            this.data.tier_details = [...tierDetails.tiers];
            this.data.free_gift_wrap_product = tierDetails.free_gift_box_and_wrap_product.product;
            this.data.perks.perks_details = [...tierDetails.perks];
        }
        const perkLimit = document.querySelectorAll(".custom-tier-tab").length;
        this.data.perks.limit = perkLimit;
        this.footer = this.querySelector("bundle-footer");
        this.productChangeEvents.forEach((event) => this.addEventListener(event, this.updateProductList.bind(this)));
        this.perkProductChangeEvents.forEach((event) => this.addEventListener(event, this.updatePerkProductList.bind(this)));
        document.documentElement.addEventListener("personalise-bundle:step-change", this.handleStepChange.bind(this));
        document.documentElement.addEventListener("personalise-bundle:clear", this.clearBundle.bind(this));
    }

    updateProductList({ detail: { product, quantity } }) {
        const productIndex = this.data.products_array.findIndex((p) => p.product_id === product.product_id);
        let currentTotalQuantity = this.data.products_array.reduce((sum, p) => sum + p.quantity, 0);

        if (productIndex !== -1) {
            const oldQuantity = this.data.products_array[productIndex].quantity;

            if (quantity === 0) {
                currentTotalQuantity -= oldQuantity;
                this.data.products_array.splice(productIndex, 1);
            } else {
                const newQuantity = quantity;
                currentTotalQuantity = currentTotalQuantity - oldQuantity + newQuantity;
                this.data.products_array[productIndex].quantity = newQuantity;
            }
        } else if (quantity > 0) {
            this.data.products_array.push({ ...product, quantity });
            currentTotalQuantity += quantity;
        }
        const totalAmount = this.data.products_array.reduce((sum, tier) => sum + (tier.quantity * tier.price), 0) / 100;
        document.documentElement.dispatchEvent(new CustomEvent("personalise-bundle:amount:changed", { detail: { amount: totalAmount } }));
        if (this.footer) {
            this.footer.renderPrice(this.data.products_array);
            this.footer.renderMiniCart(this.data);
        }
    }

    updatePerkProductList({ detail: { product, quantity, tier_index } }) {
        const mainBundle = this.closest("personalised-bundle");
        if (quantity > 0) {
            const activePerkTab = document.querySelector(".custom-tier-tab.active");
            const tierIndex = mainBundle.data.current_step === 1 ? activeProductTab.dataset.index : activePerkTab.dataset.index;
            this.data.perks.products_array.push({ ...product, quantity, tier_index: tierIndex });
        } else {
            let productIndex = this.data.perks.products_array.findIndex((p) => p.product_id === product.product_id);
            if (productIndex !== -1) {
                this.data.perks.products_array.splice(productIndex, 1);
            }
        }
        this.footer.renderPerksCart(this.data);
    }

    clearBundle() {
        let cleanedData = {
            products_array: [],
            current_amount: 0,
            current_step: 1,
            tier_details: this.data.tier_details.map((tier) => ({ ...tier, is_active: false, products_array: [] })),
            perks: {
                limit: 3,
                products_array: [],
            }
        }
        this.data = cleanedData;
        this.footer.renderPrice([]);
        this.footer.renderMiniCart(this.data);
        this.footer.renderPerksCart(this.data);
        const steps = this.closest("personalised-bundle").querySelector(".progress-steps")?.children;
        Array.from(steps).forEach((step, index) => {
            step.classList.toggle("active", false);
            this.data.tier_details[index].is_active = false
        });
        document.querySelector(".bundle-collection-tab:not(.custom-tier-tab)").click();
        document.documentElement.dispatchEvent(new CustomEvent("personalise-bundle:amount:changed", { detail: { amount: 0 } }));
    }

    handleStepChange({ detail: { step } }) {
    this.data.current_step = step;

    const step1 = this.querySelector(".personalized-bundle-step-1");
    const step2 = this.querySelector(".personalized-bundle-step-2");

    step1.classList.toggle("hidden", step === 2);
    step2.classList.toggle("hidden", step === 1);

    // 🩵 FIX: Prevent jump to footer by smoothly scrolling bundle section into view
        requestAnimationFrame(() => {
            const rect = this.getBoundingClientRect();
            const scrollTop = window.scrollY + rect.top - 100; // adjust offset as needed
            window.scrollTo({
                top: scrollTop,
                behavior: "smooth"
            });
        });
    }
}
customElements.define('personalised-bundle', PersonalisedBundle);

class BundleProgress extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.progressBar = this.querySelector("progress");
        this.tierData = this.closest("personalised-bundle").data.tier_details;
        document.documentElement.addEventListener("personalise-bundle:amount:changed", this.updateProgressBar.bind(this));
    }

    calculateProgressBarValue(amount) {
        let progressValue = 0;
        const tierLengths = this.tierData.length;
        if (amount > 0) {
            const progressPerTier = 100 / tierLengths;
            for (let i = tierLengths - 1; i >= 0; i--) {
                if (amount >= this.tierData[i].amount_limit) {
                    progressValue = progressPerTier * (i + 1);
                    break;
                }
            }
        }
        return progressValue;
    }

    updateProgressBar(e) {
        const { amount } = e.detail;
        const progressValue = this.calculateProgressBarValue(amount);
        if (this.progressBar) {
            this.progressBar.value = progressValue;
        }
        const steps = this.closest("personalised-bundle").querySelector(".progress-steps")?.children;
        if (steps) {
            Array.from(steps).forEach((step, index) => {
                step.classList.toggle("active", amount >= this.tierData[index].amount_limit);
                this.tierData[index].is_active = amount >= this.tierData[index].amount_limit;
            });
        }
    }
}

customElements.define('bundle-progress', BundleProgress);

class BundleCollectionHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.collectionTabsWrapper = this.querySelector(".bundle-collection-tabs");
        this.collectionTabs = this.querySelectorAll(".bundle-collection-tab");
        this.collectionTabsContents = this.querySelectorAll(".bundle-tab-content");
        this.collectionTabs.forEach((tab) => tab.addEventListener("click", this.handleTabChange.bind(this)));
        this.tabChangers = this.querySelectorAll(".button-navigation");
        this.tabChangers.forEach((tabChanger) => tabChanger.addEventListener("click", this.handleTabNav.bind(this)));
    }

    scrollTabIntoView(tab) {
        const tabsWrapperRect = this.collectionTabsWrapper.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const scrollLeft = tab.offsetLeft - (tabsWrapperRect.width / 2) + (tabRect.width / 2);
        this.collectionTabsWrapper.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }

    handleTabChange({ currentTarget }) {
        this.collectionTabs.forEach((tab) => tab.classList.toggle("active", tab === currentTarget));
        this.collectionTabsContents.forEach((content) => content.classList.remove("active"));
        this.querySelector(`[data-tab='${currentTarget.dataset.target}']`)?.classList.add("active");
        this.scrollTabIntoView(currentTarget);
    }

    handleTabNav({ currentTarget }) {
        const direction = currentTarget.dataset.nav;
        const currentActiveTab = this.querySelector(".bundle-collection-tab.active");
        const currentIndex = parseInt(currentActiveTab.dataset.index);
        const totalTabs = this.collectionTabs.length;
        let index = currentIndex;
        if (direction === 'next') {
            index = currentIndex === totalTabs - 1 ? 0 : currentIndex + 1;
        } else {
            index = currentIndex === 0 ? totalTabs - 1 : currentIndex - 1;
        }

        this.collectionTabs[currentIndex].classList.remove('active');
        this.collectionTabs[index].classList.add('active');
        this.collectionTabs[index].click();
    }

}

customElements.define('bundle-collection-header', BundleCollectionHeader);

class BundleProduct extends HTMLElement {
    connectedCallback() {
        const productDataEl = this.querySelector(".product-data");
        if (!productDataEl) throw new Error("Product data is required!");
        this.productData = JSON.parse(productDataEl.textContent);
        this.setAttribute('data-product-id', this.productData.product_id);
    }

    dispatchBundleEvent(eventType, detail) {
        this.closest("personalised-bundle")?.dispatchEvent(
            new CustomEvent(eventType, { detail: { ...detail, product: this.productData }, bubbles: true })
        );
    }
}
customElements.define("bundle-product", BundleProduct);

class QuantitySelector extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.quantityInput = this.querySelector(".quantity-input");
        this.quantityChangers = this.querySelectorAll(".quantity-changer");
        this.addToCartButton = this.querySelector(".product-add-to-cart");
        this.quantityChangers.forEach((changer) => changer.addEventListener("click", this.handleQuantityChange.bind(this)));
        this.addToCartButton?.addEventListener("click", this.handleAddToCart.bind(this));
        this.addEventListener("personalise-bundle:quick-add", this.handleQuickAdd.bind(this));
        document.documentElement.addEventListener("personalise-bundle:clear", this.clearBundle.bind(this));
    }

    handleQuantityChange({ currentTarget }) {
        const action = currentTarget.dataset.action;
        let quantity = parseInt(this.quantityInput.value);
        if (this.classList.contains("is-free-product")) {
            if (action === 'increment') return;
            if (action === 'decrement') {
                quantity = Math.max(0, quantity - 1);
                // this.closest(".bundle-tab-content").querySelectorAll(".quantity-changer.add").forEach((changer) => changer.disabled = false);
            }
            this.closest("bundle-product")?.dispatchBundleEvent("personalise-bundle:free-product-quantity:changed", { quantity });
        } else {
            if (action === 'increment') {
                quantity = quantity + 1;
            } else {
                quantity = Math.max(0, quantity - 1);
            }
            this.closest("bundle-product")?.dispatchBundleEvent("personalise-bundle:quantity:changed", { quantity });
        }

        this.classList.toggle("added-to-cart", quantity > 0);
        this.quantityInput.value = quantity;

    }

    handleAddToCart() {

        if (this.classList.contains("is-free-product")) {
            const data = this.closest("personalised-bundle").data;
            const activeProductTab = document.querySelector(".bundle-collection-tab.active");
            const activePerkTab = document.querySelector(".custom-tier-tab.active");
            const tierIndex = data.current_step === 1 ? activeProductTab.dataset.index : activePerkTab.dataset.index;
            const tierProducts = data.perks.products_array.filter((product) => product.tier_index === tierIndex);
            if (tierProducts.length > 0) return;
            this.quantityInput.value = 1;
            this.classList.add("added-to-cart");
            this.closest("bundle-product")?.dispatchBundleEvent("personalise-bundle:free-product-added", { quantity: 1, tier_index: tierIndex });
        } else {
            this.quantityInput.value = 1;
            this.classList.add("added-to-cart");
            this.closest("bundle-product")?.dispatchBundleEvent("personalise-bundle:product-added", { quantity: 1 });
        }
    }

    handleQuickAdd(event) {
        const data = this.closest("personalised-bundle").data;
        const activeProductTab = document.querySelector(".bundle-collection-tab.active");
        const activePerkTab = document.querySelector(".custom-tier-tab.active");
        const tierIndex = data.current_step === 1 ? activeProductTab.dataset.index : activePerkTab.dataset.index;

        if (data.current_step === 1) {
            this.quantityInput.value = 1;
            this.classList.add("added-to-cart");
            this.closest("bundle-product")?.dispatchBundleEvent("personalise-bundle:product-added", { quantity: 1, ...event.detail });
        } else {
            const tierProducts = data.perks.products_array.filter((product) => product.tier_index === tierIndex);
            if (tierProducts.length > 0) return;
            this.quantityInput.value = 1;
            this.classList.add("added-to-cart");
            this.closest("bundle-product")?.dispatchBundleEvent("personalise-bundle:free-product-added", { quantity: 1, tier_index: tierIndex });
        }
    }

    clearBundle() {
        this.quantityInput.value = 0;
        this.classList.remove("added-to-cart");
    }
}

customElements.define("quantity-selector", QuantitySelector);

class BundleFooter extends HTMLElement {
    constructor() {
        super();
        this.plusSvg = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.75 7.75V0.25H10.25V7.75H17.75V10.25H10.25V17.75H7.75V10.25H0.25V7.75H7.75Z" fill="black"/> </svg>`;
        this.closeSvg = `<svg class="icon icon-close" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99905 6.28684L13.9988 0.287109L15.713 2.0013L9.71323 8.00102L15.713 14.0007L13.9988 15.7148L7.99905 9.71521L1.99936 15.7148L0.285156 14.0007L6.28487 8.00102L0.285156 2.0013L1.99936 0.287109L7.99905 6.28684Z" fill="black"/></svg>`
        this.showMoreLabel = "Show more";
        this.showLessLabel = "Show less";
    }

    connectedCallback() {
        this.priceContainer = this.querySelector(".bundle-selection-total");
        this.nextButton = this.querySelector(".bundle-selection-next");
        this.backButton = this.querySelector(".bundle-selection-back");

        this.clearAllButton = this.querySelector(".bundle-selection-clear");
        this.checkoutButton = this.querySelector(".bundle-selection-checkout");
        this.toggleShowMoreButton = this.querySelector(".show-more");

        this.discountPriceElement = this.querySelector(".bundle-selection-total-discount");
        this.priceElement = this.querySelector(".bundle-selection-total-price");

        this.miniCart = this.querySelector(".bundle-mini-cart");
        this.perksCart = this.querySelector(".bundle-perks-cart");

        this.clearAllButton.addEventListener("click", this.clearSelection.bind(this));
        this.checkoutButton.addEventListener("click", this.checkout.bind(this));
        this.toggleShowMoreButton.addEventListener("click", this.toggleShowMore.bind(this));
        this.nextButton.addEventListener("click", this.handleStepChange.bind(this));
        this.backButton.addEventListener("click", this.handleStepChange.bind(this));

        this.bundleItems = this.querySelectorAll('.bundle-items');
        this.bundleItems.forEach((bundleItem) => bundleItem.addEventListener('click', (e) => {
            const removeButton = e.target.closest('.js-remove-item');
            if (removeButton) {
                const bundleItem = removeButton.closest('.bundle-item');
                const itemIndex = Array.from(bundleItem.parentElement.children).indexOf(bundleItem);
                const isPerksCart = bundleItem.closest('.bundle-perks-cart') !== null;
                this.handleItemRemoval(itemIndex, isPerksCart);
            }
        }));
    }

    renderPrice(products) {
        const discountPrice = products.reduce((sum, p) => sum + p.compare_at_price * p.quantity, 0);
        const price = products.reduce((sum, p) => sum + p.price * p.quantity, 0);
        if(this.discountPriceElement) this.discountPriceElement.classList.toggle("hidden", discountPrice === 0);
        if(this.discountPriceElement) this.discountPriceElement.textContent = Shopify.formatMoney(discountPrice, Shopify.money_format);
        this.priceElement.textContent = Shopify.formatMoney(price, Shopify.money_format);
        const firstTierAmount = this.closest("personalised-bundle").data.tier_details[0].amount_limit * 100;
        if (price > firstTierAmount) {
            this.nextButton.removeAttribute("disabled");
        } else {
            this.nextButton.setAttribute("disabled", true);
        }

        this.renderPerksTabs(price / 100);
    }

    renderPerksTabs(price) {
        const bundle = this.closest("personalised-bundle").data;
        const { tier_details: tiers, perks: { perks_details: perks } } = bundle;

        if (!tiers?.length || !perks?.length) return;

        tiers.forEach((tier, i) => {
            const perk = perks[i];
            const amountLimit = tier.amount_limit || Infinity;
            const collectionTab = document.querySelector(`[data-id="${perk.collection}"]`);

            if (collectionTab) {
                collectionTab.classList.toggle("hidden", price < amountLimit);
            }
        });
    }

    renderMiniCart(data) {
        const bundleItemsContainer = this.miniCart.querySelector(".bundle-items");
        bundleItemsContainer.innerHTML = "";
        const tierProducts = data.tier_details.map((tier) => ([...tier.products_array])).flat() || [];
        const products = [...data.products_array, ...tierProducts]
        let activeProductLimit = 0;
        data.tier_details.forEach((tier) => {
            if (tier.is_active) activeProductLimit = activeProductLimit + 1;
        });
        let cartItemsHTML = products.map(product => Array(product.quantity).fill(`<div class="bundle-item"> <div class="bundle-item-content"> <img src="${product.featured_image}" alt="${product.title}" /> <span class="cs-close-icon js-remove-item">${this.closeSvg}</span> </div> </div>`).join("")).join("");
        const limit = 8 - products.reduce((sum, p) => sum + p.quantity, 0);

        if (limit > 0) {
            cartItemsHTML += Array(limit).fill(`<div class="bundle-item empty"> <div class="bundle-item-content"> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.75 7.75V0.25H10.25V7.75H17.75V10.25H10.25V17.75H7.75V10.25H0.25V7.75H7.75Z" fill="black"/> </svg> </div> </div>`).join("");
        }
        bundleItemsContainer.innerHTML = cartItemsHTML;
    }

    renderPerksCart(data) {
        const bundleItemsContainer = this.perksCart.querySelector(".bundle-items");
        bundleItemsContainer.innerHTML = "";
        const products = data.perks.products_array;
        let cartItemsHTML = products.map(product => Array(product.quantity).fill(`<div class="bundle-item"> <div class="bundle-item-content"> <img src="${product.featured_image}" alt="${product.title}" /> <span class="cs-close-icon js-remove-item">${this.closeSvg}</span> </div> </div>`).join("")).join("");
        const limit = data.perks.limit - products.reduce((sum, p) => sum + p.quantity, 0);
        // if (limit > 0) {
        //     cartItemsHTML += Array(limit).fill(`<div class="bundle-item empty"> <div class="bundle-item-content"> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.75 7.75V0.25H10.25V7.75H17.75V10.25H10.25V17.75H7.75V10.25H0.25V7.75H7.75Z" fill="black"/> </svg> </div> </div>`).join("");
        // }
        if (limit > 1) {
            cartItemsHTML = `<div class="bundle-item empty"> <div class="bundle-item-content"> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.75 7.75V0.25H10.25V7.75H17.75V10.25H10.25V17.75H7.75V10.25H0.25V7.75H7.75Z" fill="black"/> </svg> </div> </div>`;
        }
        bundleItemsContainer.innerHTML = cartItemsHTML;
    }

    toggleShowMore({ currentTarget }) {
        const bundleItemsWrapper = currentTarget.closest(".bundle-selection-items").querySelector(".bundle-items");
        bundleItemsWrapper.classList.toggle("active");
        currentTarget.querySelector(".show-text").innerHTML = bundleItemsWrapper.classList.contains("active") ? this.showLessLabel : this.showMoreLabel;
    }

    // handleItemRemoval(itemIndex) {
    //     const mainBundle = this.closest('personalised-bundle');
    //     let currentItem = null;
    //     let itemPosition = 0;
    //     for (const product of mainBundle.data.products_array) {
    //         itemPosition += product.quantity;
    //         if (itemIndex < itemPosition) {
    //             currentItem = product;
    //             break;
    //         }
    //     }

    //     const perkProducts = mainBundle.data.perks.products_array;
    //     if (!currentItem) {
    //         for (const product of perkProducts) {
    //             itemPosition += product.quantity;
    //             if (itemIndex < itemPosition) {
    //                 currentItem = product;
    //                 break;
    //             }
    //         }
    //     }

    //     const productContainer = mainBundle.querySelector(`bundle-product[data-product-id="${currentItem.product_id}"]`);
    //     if (productContainer) {
    //         const quantitySelector = productContainer.querySelector('quantity-selector');
    //         if (quantitySelector) {
    //             const quantityInput = quantitySelector.querySelector('.quantity-input');
    //             const newQuantity = currentItem.quantity - 1;
    //             quantityInput.value = newQuantity;

    //             if (newQuantity === 0) {
    //                 quantitySelector.classList.remove('added-to-cart');
    //             }
    //         }
    //     }

    //     let eventName = mainBundle.data.current_step === 1 ? 'personalise-bundle:quantity:changed' : 'personalise-bundle:free-product-quantity:changed';
    //     mainBundle.dispatchEvent(
    //         new CustomEvent(eventName, {
    //             detail: { product: currentItem, quantity: currentItem.quantity - 1 },
    //             bubbles: true
    //         })
    //     );
    // }

    handleItemRemoval(itemIndex, isPerksCart = false) {
        const mainBundle = this.closest('personalised-bundle');
        let currentItem = null;
        let itemPosition = 0;
        
        const productsArray = isPerksCart ? mainBundle.data.perks.products_array : mainBundle.data.products_array;
        
        for (const product of productsArray) {
            itemPosition += product.quantity;
            if (itemIndex < itemPosition) {
                currentItem = product;
                break;
            }
        }

        if (!currentItem) return;

        const productContainer = mainBundle.querySelector(`bundle-product[data-product-id="${currentItem.product_id}"]`);
        if (productContainer) {
            const quantitySelector = productContainer.querySelector('quantity-selector');
            if (quantitySelector) {
                const quantityInput = quantitySelector.querySelector('.quantity-input');
                const newQuantity = currentItem.quantity - 1;
                quantityInput.value = newQuantity;

                if (newQuantity === 0) {
                    quantitySelector.classList.remove('added-to-cart');
                }
            }
        }

        let eventName = isPerksCart ? 'personalise-bundle:free-product-quantity:changed' : 'personalise-bundle:quantity:changed';
        mainBundle.dispatchEvent(
            new CustomEvent(eventName, {
                detail: { product: currentItem, quantity: currentItem.quantity - 1 },
                bubbles: true
            })
        );
    }

    handleStepChange({ currentTarget }) {
        const step = currentTarget.classList.contains("bundle-selection-next") ? 2 : 1;
        const isStepOne = step === 1;
        console.log({ isStepOne });
        this.clearAllButton.classList.toggle("hidden", !isStepOne);
        this.nextButton.classList.toggle("hidden", !isStepOne);
        this.checkoutButton.classList.toggle("hidden", isStepOne);
        this.backButton.classList.toggle("hidden", isStepOne);
        this.miniCart.classList.toggle("hidden", !isStepOne);
        this.perksCart.classList.toggle("hidden", isStepOne);
        this.priceContainer.style.visibility = isStepOne ? "visible" : "hidden";
        document.documentElement.dispatchEvent(new CustomEvent("personalise-bundle:step-change", { detail: { step } }));
    }

    clearSelection() {
        document.documentElement.dispatchEvent(new CustomEvent("personalise-bundle:clear", { detail: { products_array: [], quantity: 0 } }));
    }

    checkout() {
        // console.log("Checking out!");
        const mainBundle = this.closest("personalised-bundle");
        console.log(mainBundle.data);
        const allProducts = [...mainBundle.data.products_array, ...mainBundle.data.perks.products_array];
        // const items = allProducts.map((p) => ({ id: p.variant_id || p.id, quantity: p.quantity }));
        const items = allProducts.map((p) => {
            const item = p.has_gift_card_product ? { id: p.variant_id || p.id, quantity: p.quantity, properties: { "_has_gift_card_product": "true" } } : { id: p.variant_id || p.id, quantity: p.quantity };
            return item;
        });
        const freeGiftBoxAndWrapProduct = mainBundle.data.free_gift_wrap_product;
        if (freeGiftBoxAndWrapProduct) {
            items.push({ id: freeGiftBoxAndWrapProduct, quantity: 1 });
        }
        let formData = { 'items': items };
        const header = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) };
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        cart.setActiveElement(document.activeElement);
        const _this = this;
        fetch(`${window.Shopify.routes.root}cart/add.js?sections=${cart.getSectionsToRender().map((section) => section.id).join(",")}`, header)
            .then(response => response.json())
            .then((response) => {
                console.log(response);
                cart.renderContents(response);
                _this.clearSelection();
            })
            .catch((error) => {
                console.error('Error:', error);
            })
            .finally(() => {
                if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            });
    }
}

customElements.define("bundle-footer", BundleFooter);